var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-border",style:('height:'+_vm.inputHeight+'px;width:'+(
    isNaN(_vm.inputWidth)
      ?_vm.inputWidth.includes('%')?_vm.inputWidth:'100%'
      :_vm.inputWidth+'px'
  )),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{ref:"box",staticClass:"input-box df-c-fs"},[_c('span',{staticClass:"cursor-blink",class:{'placeholder':_vm.isPlaceholder,'inputable':_vm.inputable}},[_vm._v(_vm._s(_vm.inputValueHtml))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }